module.exports = __webpack_public_path__ + "img/app-store-badge.f83c86e9.png";